import React from 'react';
import { Card, Checkbox, Col, Form, Row } from 'antd';
import './styles.css';

const CheckGroupCardSociogram = ({
  questionText,
  question,
  name,
  required,
  onChange,
  sm,
  md,
  lg,
  xxl,
  options,
  classMate,
}) => {
  return (
    <Card
      title={
        <div>
          {questionText} {classMate ? <b>{classMate.name}</b> : null}
          {question?.isChildren ? '?' : null}
        </div>
      }
      className="multipleSelectCard_card"
    >
      <Card type="inner">
        <Form.Item
          name={name}
          rules={[
            { required: { required }, message: '*Respuesta obligatoria' },
          ]}
        >
          <Checkbox.Group
            style={{ width: '100%' }}
            value={options ? options[0]?.id : null}
          >
            <Row gutter={[16, 16]}>
              {options && options.length
                ? options.map((option) => {
                    return (
                      <Col
                        key={`check-item-${option.id}`}
                        sm={sm}
                        md={md}
                        lg={lg}
                        xxl={xxl}
                      >
                        <Checkbox
                          onChange={() => {
                            onChange(name, question, option.id, [classMate]);
                          }}
                          value={option.name}
                        >
                          <span className="checkbox-text">{option.name}</span>
                        </Checkbox>
                      </Col>
                    );
                  })
                : null}
            </Row>
          </Checkbox.Group>
        </Form.Item>
      </Card>
    </Card>
  );
};

export default CheckGroupCardSociogram;
